export class EramSectorTrack {
    constructor(trackId, dbPosition = "NE", ldrLength = 1) {
        this.trackId = trackId;
        this.dbPosition = dbPosition;
        this.ldrLength = ldrLength;
    }
    trackId;
    communicationStatus = null;
    haloRadius = null;
    pointouts = [];
    cpdlcFieldDialogIdMap = {};
    didAutoPop = false;
    dbType = "LDB";
    tempFdb = false;
    ldrLength;
    dbPosition;
    didSetDefaultDbPosition = false;
    isDwellLocked = false;
    // quick vector
    qvParams = null;
    line4Suppressed = false;
}
//# sourceMappingURL=eramSectorTrack.js.map